export var eventNotification = function eventNotification(api) {
  return {
    trigger: {
      index: function index(params) {
        return api.get('/event-notification/trigger', {
          params: params
        });
      },
      get: function get(id) {
        return api.get("/event-notification/trigger/".concat(id));
      },
      post: function post(data) {
        return api.post('/event-notification/trigger', {
          trigger: data
        });
      },
      put: function put(id, data) {
        return api.put("/event-notification/trigger/".concat(id), {
          updates: data
        });
      },
      delete: function _delete(id) {
        return api.delete("/event-notification/trigger/".concat(id));
      }
    },
    action: {
      post: function post(triggerId, data) {
        return api.post("/event-notification/trigger/".concat(triggerId, "/action"), {
          action: data
        });
      },
      put: function put(triggerId, actionId, data) {
        return api.post("/event-notification/trigger/".concat(triggerId, "/action/").concat(actionId), {
          updates: data
        });
      },
      delete: function _delete(triggerId, actionId) {
        return api.delete("/event-notification/trigger/".concat(triggerId, "/action/").concat(actionId));
      }
    }
  };
};